export default function Achievements() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold text-gray-900 mb-4">Achievements</h1>
      <div className="card">
        <p className="text-gray-600">This is the Achievements page. Content coming soon...</p>
      </div>
    </div>
  );
}
